'use strict';

var _ = require('lodash');
var ColumnCustomizationController = function ColumnCustomizationController($scope, Tree, GroupNameService, CalcColumnNameService, treeKeyboardSupport) {
  var tree = new Tree($scope);
  $scope.editValues = {};
  $scope.isEditing = false;
  $scope.isEditingGroup = false;
  $scope.isEditingColumn = false;
  $scope.isAddingToGroupDisabled = true;
  $scope.isRemovingFromGroupDisabled = true;
  $scope.isMovingUpAllowed = true;
  $scope.isMovingDownAllowed = true;
  $scope.columnList = [];
  $scope.showDependentCustomColumnsWarning = false;
  $scope.dependentColumnsCount = 0;
  $scope.rebuildTree = tree.rebuildTree.bind(tree);
  $scope.updateTreeModelAfterDragAndDrop = tree.updateTreeModelAfterDragAndDrop.bind(tree);
  $scope.isApplicationDefaultTree = tree.isApplicationDefaultTree.bind(tree);
  $scope.isJqxTreeVisible = false;
  $scope.openDialogActions = function () {
    treeKeyboardSupport.addHotKeys($scope);
  };
  $scope.closeDialogActions = function () {
    treeKeyboardSupport.removeHotKeys();
  };
  $scope.determineEditPanelVisibility = function () {
    var selectedNode = tree.getSelectedNode();
    var selectionDefined = _.isUndefined(selectedNode) === false;
    $scope.isEditingGroup = selectionDefined && tree.isEditableGroup(selectedNode.id);
    $scope.isEditingColumn = selectionDefined && tree.isEditableColumn(selectedNode.id);
    $scope.isEditing = $scope.isEditingGroup || $scope.isEditingColumn;
  };
  $scope.onCheckChange = function (event) {
    var args = event.args;
    tree.checkItem(args.element.id, args.checked);
  };
  $scope.determineButtonsAvailability = function () {
    if (tree.ready()) {
      $scope.isAddingToGroupDisabled = $scope.addingToGroupDisabled();
      $scope.isRemovingFromGroupDisabled = $scope.removingFromGroupDisabled();
      $scope.isMovingUpAllowed = $scope.isMovingDisabled('up');
      $scope.isMovingDownAllowed = $scope.isMovingDisabled('down');
    }
  };
  $scope.onSelect = function (id) {
    tree.setSelectedNode(id);
    tree.grabFocus();
    $scope.determineEditPanelVisibility();
    $scope.determineButtonsAvailability();
    $scope.setValuesIfEditing();
  };
  $scope.applyChanges = function () {
    var columns = tree.getCommonModelFromTreeModel();
    $scope.applyChangesCallback({
      columns: columns
    });
  };
  $scope.cancelChanges = function () {};
  $scope.resetChanges = function () {
    tree.resetSettings();
    $scope.isEditingGroup = false;
    $scope.isEditingColumn = false;
    $scope.isEditing = false;
  };
  $scope.moveUp = function () {
    if (!$scope.isMovingDisabled('up')) {
      var selectedItem = tree.getSelectedItem();
      tree.moveItemUp(selectedItem);
    }
  };
  $scope.moveDown = function () {
    if (!$scope.isMovingDisabled('down')) {
      var selectedItem = tree.getSelectedItem();
      tree.moveItemDown(selectedItem);
    }
  };
  $scope.addToGroup = function () {
    if ($scope.addingToGroupDisabled() === false) {
      var selectedItem = tree.getSelectedItem();
      tree.moveItemToGroup(selectedItem);
    }
  };
  function disableMovementButtons(selectedItem) {
    return !selectedItem || $scope.isInvalidForm();
  }
  $scope.addingToGroupDisabled = function () {
    var selectedItem = tree.getSelectedItem();
    return disableMovementButtons(selectedItem) || tree.isAddingToGroupDisabled(selectedItem);
  };
  $scope.isMovingDisabled = function (direction) {
    var selectedItem = tree.getSelectedItem();
    var isDataDrivenGroupItem = !!(selectedItem && selectedItem.parentId && tree.getNodeById(selectedItem.parentId).dataDrivenColumn);
    return disableMovementButtons(selectedItem) || !tree.hasItemSibling(selectedItem.id, direction === 'up') || isDataDrivenGroupItem;
  };
  $scope.removeFromGroup = function () {
    if ($scope.removingFromGroupDisabled() === false) {
      var selectedItem = tree.getSelectedItem();
      tree.removeItemFromGroup(selectedItem);
    }
  };
  $scope.removingFromGroupDisabled = function () {
    var selectedItem = tree.getSelectedItem();
    return disableMovementButtons(selectedItem) || tree.isRemovingFromGroupDisabled(selectedItem);
  };
  $scope.isAddingNewItemDisabled = function () {
    return $scope.isInvalidForm();
  };
  $scope.addGroup = function () {
    var node = tree.getSelectedItem();
    if (node === null) {
      node = tree.getFirstTreeItem();
    }
    if (node === null || node.level === 0) {
      var previousNodeId = node === null ? null : node.id;
      var name = GroupNameService.getName();
      tree.addGroup(name, previousNodeId);
    }
  };
  $scope.addCalculatedColumn = function () {
    var node = tree.getSelectedItem();
    if (node === null) {
      node = tree.getFirstTreeItem();
    }
    var previousNodeId = node === null ? null : node.id;
    var name = CalcColumnNameService.getName();
    tree.addCalculatedColumn(name, previousNodeId);
  };
  $scope.removeCustomGroup = function () {
    if ($scope.isEditingGroup === true) {
      $scope.isEditing = false;
      $scope.isEditingGroup = false;
      tree.removeCustomGroup(tree.getSelectedItem().id);
    }
  };
  $scope.setValuesIfEditing = function () {
    if ($scope.isEditingGroup === true) {
      $scope.editValues.columnName = undefined;
      $scope.editValues.groupName = tree.getSelectedNodeLabel();
    }
    if ($scope.isEditingColumn === true) {
      var node = tree.getSelectedNode();
      var formula = node.formula || {};
      $scope.columnList = tree.getCalculableColumns(true);
      $scope.editValues.groupName = undefined;
      $scope.editValues.columnName = node.label;
      $scope.editValues.leftOperand = _.find($scope.columnList, {
        id: formula.leftOperand
      });
      $scope.editValues.operator = formula.operator || '+';
      $scope.editValues.rightOperand = _.find($scope.columnList, {
        id: formula.rightOperand
      }) || {
        label: formula.rightOperand
      };
      triggerFormulaValidations();
    }
  };
  function operandToValue(operand) {
    return operand ? operand.id || operand.label : undefined;
  }
  function triggerFormulaValidations() {
    triggerValidations('leftOperand', $scope.editValues.leftOperand);
    triggerValidations('rightOperand', $scope.editValues.rightOperand);
  }
  $scope.editValuesWatcher = function () {
    if (tree.ready() === true) {
      var vals = $scope.editValues;
      if ($scope.isEditingGroup) {
        tree.setItemLabel(tree.getSelectedItem(), vals.groupName || '');
      } else if ($scope.isEditingColumn) {
        tree.setItemLabel(tree.getSelectedItem(), vals.columnName || '');
        tree.updateFormula(operandToValue(vals.leftOperand), vals.operator, operandToValue(vals.rightOperand));
        triggerFormulaValidations();
      }
    }
  };
  $scope.isValidNewGroupName = function (groupName) {
    return tree.isValidNewGroupName(groupName);
  };
  $scope.isValidNewColumnName = function (columnName) {
    return tree.isValidNewColumnName(columnName);
  };
  $scope.cycleDetected = function () {
    return tree.cycleDetected();
  };
  $scope.isValidColumnOrValue = function (value) {
    return tree.isValidColumnOrValue(value);
  };
  $scope.removeCustomColumn = function () {
    if ($scope.isEditingColumn === true) {
      $scope.isEditing = false;
      $scope.isEditingColumn = false;
      tree.removeCustomColumn(tree.getSelectedItem().id);
      $scope.showDependentCustomColumnsWarning = false;
    }
  };
  $scope.removeCustomItem = function () {
    var customColumnId;
    if ($scope.isEditingColumn) {
      customColumnId = tree.getSelectedItem().id;
      $scope.dependentColumnsCount = _.size(tree.getDependentCustomColumns(customColumnId));
      $scope.showDependentCustomColumnsWarning = tree.hasDependentCustomColumns(customColumnId);
      if (!$scope.showDependentCustomColumnsWarning) {
        $scope.removeCustomColumn();
      }
    } else if ($scope.isEditingGroup) {
      $scope.removeCustomGroup();
    }
  };
  $scope.cancelCustomColumnRemoval = function () {
    $scope.showDependentCustomColumnsWarning = false;
  };
  $scope.getTree = function () {
    return tree;
  };
  $scope.isDropdownItemSelected = function (operand, label) {
    return $scope.editValues[operand] === label;
  };

  // this has been added because we don't use a combo box component that would support validations
  // we need to trigger it manually when a user selects a value from a dropdown menu
  // the code can be removed if we decide to use something different
  function triggerValidations(part, value) {
    $scope.customColumnForm[part].$setDirty();
    $scope.customColumnForm[part].$parsers.forEach(function (parser) {
      parser(value);
    });
  }
  $scope.isInvalidForm = function () {
    return $scope.isEditingGroup && $scope.newGroupForm.$invalid || $scope.isEditingColumn && $scope.customColumnForm.$invalid;
  };
  $scope.isGroupNameUsed = function () {
    var groupName = $scope.newGroupForm.groupName;
    return groupName.$dirty && groupName.$error.groupNameAlreadyUsed;
  };
  $scope.isGroupNameEmpty = function () {
    var groupName = $scope.newGroupForm.groupName;
    return groupName.$dirty && groupName.$error.required;
  };
  $scope.isOperatorMissing = function () {
    var operator = $scope.customColumnForm.operator;
    return operator.$dirty && operator.$error.required;
  };
  $scope.isLeftOperandMissing = function () {
    var leftOperand = $scope.customColumnForm.leftOperand;
    return leftOperand.$dirty && (leftOperand.$error.required || leftOperand.$error.validColumnOrValue);
  };
  $scope.isRightOperandMissing = function () {
    var rightOperand = $scope.customColumnForm.rightOperand;
    return rightOperand.$dirty && (rightOperand.$error.required || rightOperand.$error.validColumnOrValue);
  };
  $scope.isColumnNameUsed = function () {
    var columnName = $scope.customColumnForm.columnName;
    return columnName.$dirty && columnName.$error.columnNameAlreadyUsed;
  };
  $scope.isColumnNameEmpty = function () {
    var columnName = $scope.customColumnForm.columnName;
    return columnName.$dirty && columnName.$error.required;
  };
  $scope.cycleErrorDetected = function () {
    var leftOperand = $scope.customColumnForm.leftOperand;
    var rightOperand = $scope.customColumnForm.rightOperand;
    return leftOperand.$dirty && leftOperand.$error.cycleDetected || rightOperand.$dirty && rightOperand.$error.cycleDetected;
  };
};
ColumnCustomizationController.$inject = ['$scope', 'JQXTreeFactory', 'GroupNameService', 'CalcColumnNameService', 'JQXTreeKeyboardSupportService'];
module.exports = ColumnCustomizationController;